import { Injectable } from '@angular/core';

@Injectable()
export class UtilitiesService {

  constructor() { }

  castTimeStampToDate(value: any): string {

    let timestampValue = ((value.timestamp + value.offset) * 1000);
    let fuckingDate: Date = new Date(timestampValue);

    return fuckingDate.getFullYear().toString() + "-" + (fuckingDate.getMonth() + 1).toString() + "-" + (fuckingDate.getDate() + 1).toString();

  }

  //API DE PHP  
  getURL(metodo: string): string {
    //EPRAC PC
    //return "http://localhost:8080/prod/eflowTPL_api/web/api/" + metodo;
    //server ILG URL TEST   
    //return "http://172.16.1.17:8000/test/eflowTPL_api/web/api/" + metodo;
    //server ILG URL PROD    
    //return "http://172.16.1.18:8000/eflowTPL_api/web/api/" + metodo; 
    //return   "http://172.16.1.18:8000/eflowTPL_api/web/" + metodo;

    //return "http://172.16.1.49:4430/eflowTPL_api/web/api/" + metodo; 
    //return "http://172.16.1.49:8888/eflowTPL_api/web/api/" + metodo; 

    // return "http://168.197.189.117:8888/eflowTPL_api/web/api/"+ metodo; 

    //NUEVA IP 30-10-2019  -- BLUE
    // return "http://190.123.229.173:8888/eflowTPL_api/web/api/" + metodo;


    // ilg panama pruebas locales 
    // return "http://192.168.1.12:9090/eflowTPL_api/web/api/" + metodo;
    //return "http://192.168.1.2:9095/API/" + metodo;


    // showroom

     // return 'http://192.168.1.126:90/eflowTPL_api/web/api/' + metodo;


    // ILG PANAMA PRUEBAS
   // return 'http://172.23.55.8:80/eflowTPL_API_PRUEBAS/web/api/' + metodo;

    // ILG NUEVA PANAMA PROD
    // return "http://172.23.55.8:80/eflowTPL_api/web/api/" + metodo;

    //BLU SERVER
    //return "http://186.5.131.46:8888/eflowTPL_api/web/api/" + metodo;
    //return "http://186.5.131.46:8888/eflowTPL_api/web/api/" + metodo;

    //Blue
    //return "http://186.5.131.46:8888/eflowTPL_api/web/api/" + metodo;

    // return "http://172.16.16.13/eflowTPL_api/web/api/"  + metodo;

    //return "http://168.197.189.117:8888/eflowTPL_api/web/api/"  + metodo;

     // ILG NUEVA CR PROD
      return "https://tpl.ilglogistics.com/eflowTPL_API_CR_PROD/web/api/" + metodo;

  }

  // EL API DEL IIS
  getURLIIS(metodo: string): string {
    //pruebas
    // return "http://localhost:5000/api/" + metodo;

    //return "http://192.168.1.126:9095/API/API/" + metodo;


    //ILG PRUEBAS
   //  return "http://172.23.55.8:8080/API/" + metodo;

     //ILG PROD
     //return "http://172.23.55.8:8081/API/" + metodo; 

     //ILG NUEVO CR PROD
     return "https://tpl.ilglogistics.com:8084/API/" + metodo;
  }

  getEscapeString(_String: string) {
    return encodeURIComponent(_String);
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/utilities.service.ts